export { default } from './HashAnchor';



// WEBPACK FOOTER //
// ./src/components/atoms/HashAnchor/index.js